export default __webpack_public_path__ + "static/media/profile-1.4f9d2540.png";